module.exports = __webpack_public_path__ + "Posters0011-3c2976a511cb5680a731d1b880404ae5.png";